<template>

    <div>
        <div class="row m-0 p-0">

            <div class="col-md-12 m-0 p-0" v-if="showHeader">
                <span class="text-left text-truncate" variant="primary">{{ campo.titulo }}</span>
            </div>
                            
            <div class="col-md-4 m-0 p-0">                
                <base-input :label="campo.conf && campo.conf.tituloLocal ? campo.conf.tituloLocal : 'Local de prestação de serviço'" class="mb-0">
                    <b-form-radio v-for="opcao in campo.locais" v-bind:key="opcao.valor"
                        :name="campo.nome + ':' + local.id + ':local-prestacao-servico'" :disabled="leitura"
                        v-model="local.local" :value="opcao.valor">{{ opcao.descricao }}</b-form-radio>
                    <b-form-input v-if="local.local === '#outro#'" :readonly="leitura" type="text"
                        placeholder="Informe aqui" :maxlength="campo.maxLength !== null ? campo.maxLength : 500"
                        v-model="local.outroLocal" />
                </base-input>
            </div>
            <div class="col-md-4 m-0 py-0 px-2">
                <base-input :label="campo.conf && campo.conf.tituloSetor ? campo.conf.tituloSetor : 'Setor de trabalho na Instituição'" class="mb-0">
                    <b-form-radio v-for="opcao in campo.setores" v-bind:key="opcao.valor"
                        :name="campo.nome + ':' + local.id + ':setor-trabalho-instituicao'" :disabled="leitura"
                        v-model="local.setor" :value="opcao.valor">{{ opcao.descricao }}</b-form-radio>
                    <b-form-input v-if="local.setor === '#outro#'" :readonly="leitura" type="text"
                        placeholder="Informe aqui" :maxlength="campo.maxLength !== null ? campo.maxLength : 500"
                        v-model="local.outroSetor" />
                </base-input>
            </div>
            <div class="col-md-4 m-0 py-0 pl-2 pr-0">
                <div class="row m-0 p-0">
                    <div class="col-md-12 my-1 mb-0 mt-2 p-0">
                        <base-input :label="campo.conf && campo.conf.tituloCoordenador ? campo.conf.tituloCoordenador : 'Qual o nome do coordenador na Instituição de trabalho acima?'" class="mb-0">
                            <b-form-input :readonly="leitura" type="text" placeholder="Nome do coordenador"
                                :maxlength="campo.maxLength !== null ? campo.maxLength : 500"
                                v-model="local.nomeCoordenador" />
                        </base-input>
                    </div>
                </div>
            </div>
        </div>        
    </div>
</template>
<script>

export default {
    props: ['showHeader', 'local', 'leitura', 'campo'],
    components: {
    },
    data() {
        return {

        }
    },
    methods: {
        
    }
}

</script>
<style></style>